import type { ResultOf } from '~publish/graphql'

import type { GetLinkedInVerifiedSkills } from './useLinkedInCapabilitiesSettings'

type LinkedInProfile = {
  id: string
  organizationId?: string | null
  service: string
  service_type?: string | null
  api_version?: string | null
  displayName?: string | null
  handle?: string | null
  disabled?: boolean | null
  isLocked?: boolean | null
  service_username?: string | null
  serviceUsername?: string | null
  username?: string | null
}

type LinkedInVerifiedCapability = ResultOf<
  typeof GetLinkedInVerifiedSkills
>['channel']['capabilities']['capabilities'][number]

type ChannelCapabilityKey = LinkedInVerifiedCapability['capabilityKey']

const PROFILE_SECTION_TITLE =
  'Show your Buffer Capabilities on your LinkedIn Profile'
const PAGE_SECTION_TITLE =
  'Show your Buffer Capabilities on your LinkedIn Profile'
const PAGE_SECTION_DESCRIPTION =
  'Showcase capabilities on your LinkedIn profile based on your Buffer activity.'
const LINKEDIN_CAPABILITIES_QUERY_PARAM = 'linkedincapabilities'
// Keep in sync with `LINKEDIN_CAPABILITIES_SECTION_ID` in
// domains/app-shell/src/components/Modal/modals/LinkedInCapabilities/constants.ts.
const LINKEDIN_CAPABILITIES_SCROLL_HASH = 'linkedin-capabilities'
const LINKEDIN_CREDIBILITY_SIGNALS_SCOPE = 'rw_credibilitySignals'
const LINKEDIN_CAPABILITIES_HELP_CENTER_URL =
  'https://support.buffer.com/articles/using-linkedin-capabilities-in-buffer-JaWCidK1Fv?utm_source=buffer&utm_medium=learn-more-link&utm_campaign=learn-more'

export {
  LINKEDIN_CAPABILITIES_HELP_CENTER_URL,
  LINKEDIN_CAPABILITIES_QUERY_PARAM,
  LINKEDIN_CAPABILITIES_SCROLL_HASH,
  LINKEDIN_CREDIBILITY_SIGNALS_SCOPE,
  PAGE_SECTION_DESCRIPTION,
  PAGE_SECTION_TITLE,
  PROFILE_SECTION_TITLE,
}
export type {
  ChannelCapabilityKey,
  LinkedInProfile,
  LinkedInVerifiedCapability,
}
